import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://220b97bab6c54ec0b3787598c18efc52@o356455.ingest.us.sentry.io/2814184',
  integrations: [],
});
